const routes={
    googleAdsGrader: "/google-ads-grader",
    seoSiteGrader: "/seo-site-grader",
    leadGeneration:"/lead-generation.html",
}

export default routes;